import Glide from 'glidejs';
import LazyLoad from 'lazyload';
import { setCount, carouselText } from './carouselInit';
import { throttle } from 'throttle-debounce';

const MOBILE_GLIDE_BREAKPOINT = 768;

/**
 * Standard Glide instantiation
 */
export const glidify = () => {
  const glides = document.querySelectorAll('[data-glide]');
  if (!glides.length) return;

  glides.forEach((glide) => {
    const config = glide.dataset.gliderConfig ? JSON.parse(glide.dataset.gliderConfig) : {};
    const id = glide.dataset.glideId ? glide.dataset.glideId : null;
    const type = config.type ? config.type : null;

    if (id) {
      // Only create glide if it hasn't been created yet.
      if (!window.blubolt.glides[id]) {
        const glideInstance = new Glide(glide, config).mount();
        if (id === 'carousel') {
          glideInstance.on(['swipe.end'], () => {
            setCount()
            carouselText()
          });
        }

        if (type === 'carousel') {
          glideInstance.on(['run'], () => {
            // Lazyloading doesn't work for items generated by the carousel so we're ensuring it lazy loads if the user scrolls past them.
            if (document.querySelectorAll('[data-glide] img[data-lazy-load]:not(.loaded)').length > 0) {
              new LazyLoad({
                elements_selector: '[data-glide] img[data-lazy-load]:not(.loaded)' // eslint-disable-line camelcase
              });
            }
          });
        }

        window.blubolt.glides[id] = glideInstance;
      }
    } else {
      console.info('Please add data-glide-id to the slide');
    }
  });
};

/**
 * Glide instantiation specific for the PDP
 */
export const initPDPSlider = () => {
  // the PDP slider only triggers on mobile
  const glide = document.querySelector('[data-glide-pdp]');
  if (!glide) return;

  const initGlideOnMobile = () => {
    if (window.innerWidth >= MOBILE_GLIDE_BREAKPOINT) {
      // Destroy glide slider on large devices
      if (window.blubolt.glides) {
        const id = glide.dataset.glideId ? glide.dataset.glideId : null;
        if (window.blubolt.glides[id]) {
          window.blubolt.glides[id].destroy()
          window.blubolt.glides = window.blubolt.glides.splice(id, 1);
        }
      }
    } else {
      const config = glide.dataset.gliderConfig ? JSON.parse(glide.dataset.gliderConfig) : {};
      const id = glide.dataset.glideId ? glide.dataset.glideId : null;

      if (id) {
        // Only create glide if it hasn't been created yet.
        if (!window.blubolt.glides[id]) {
          const glideInstance = new Glide(glide, config).mount();
          if (window.updateProductByImagePosition) {
            glideInstance.on(['mount.after', 'run'], () => {
              const currentIndex = glideInstance.index;
              window.blubolt.updateProductByImagePosition(currentIndex + 1)
            });
          }
          window.blubolt.glides[id] = glideInstance;
        }
      } else {
        console.info('Please add data-id to the slide');
      }
    }
  }

  initGlideOnMobile();
  window.addEventListener('resize', throttle(500, false, () => initGlideOnMobile()));
}


/**
 * Glide instantiation specific for Mobile
 */
export const initMOBSlider = () => {
  // the PDP slider only triggers on mobile
  const glides = document.querySelectorAll('[data-glide-mob]');
  if (!glides.length) return;

  glides.forEach((glide) => {
    const initGlideOnMobile = () => {
      if (window.innerWidth >= MOBILE_GLIDE_BREAKPOINT) {
      // Destroy glide slider on large devices
        if (window.blubolt.glides) {
          const id = glide.dataset.glideId ? glide.dataset.glideId : null;
          if (window.blubolt.glides[id]) {
            window.blubolt.glides[id].destroy()
            window.blubolt.glides = window.blubolt.glides.splice(id, 1);
          }
        }
      } else {
        const config = glide.dataset.gliderConfig ? JSON.parse(glide.dataset.gliderConfig) : {};
        const id = glide.dataset.glideId ? glide.dataset.glideId : null;

        if (id) {
        // Only create glide if it hasn't been created yet.
          if (!window.blubolt.glides[id]) {
            const glideInstance = new Glide(glide, config).mount();
            window.blubolt.glides[id] = glideInstance;
          }
        } else {
          console.info('Please add data-id to the slide');
        }
      }
    }

    initGlideOnMobile();
    window.addEventListener('resize', throttle(500, false, () => initGlideOnMobile()));
  })
}

export default glidify